<template>
  <div class="layout">
    <Layout>
      <AdminHeader />
      <Layout>
        <Sider hide-trigger :style="{background: '#fff'}">
          <AdminLeftMenu />
          <div class="slider-sep"></div>
        </Sider>
        <Layout class="admin-right-wrap">
          <AdminContentBread />
          <!--页面内容主体开始-->
          <Content class="admin-wrap">
            <Form ref="formValidate" :model="formValidate" :rules="ruleValidate" :label-width="80">
              <FormItem label="登录名" prop="userName">
                <Input v-model="formValidate.userName" placeholder="请输入登录名"></Input>
              </FormItem>
              <FormItem label="密码" prop="password">
                <Input v-model="formValidate.password" placeholder="请输入密码"></Input>
              </FormItem>
              <FormItem label="确认密码" prop="rePassword">
                <Input v-model="formValidate.rePassword" placeholder="请输入确认密码"></Input>
              </FormItem>
              <FormItem label="所属机构" prop="associationId">
                <Select v-model="formValidate.associationId" :label-in-value="true" placeholder="请选择管理员所属机构" @on-change="associationSelect">
                  <Option v-for="(item, index) in associatins" :key="index" :value="item.assoId">{{item.assoName}}</Option>
                </Select>
              </FormItem>
              <FormItem label="用户角色" prop="level">
                <Select v-model="formValidate.level" placeholder="请选择管理员角色">
                  <Option :value="1">内容管理员</Option>
                  <Option :value="2">协会审核管理员</Option>
                  <Option :value="3">会员管理员</Option>
                  <Option :value="4">协会超级管理员</Option>
                  <Option :value="99">站点超级管理员</Option>
                </Select>
              </FormItem>
              <FormItem>
                <Button type="primary" @click="handleSubmit('formValidate')">保存</Button>
              </FormItem>
            </Form>
          </Content>
          <!--页面内容主体结束-->
        </Layout>
      </Layout>
    </Layout>
  </div>
</template>
<script>
import axios from "axios"
import AdminLeftMenu from '@/components/AdminLeftMenu.vue'
import AdminContentBread from '@/components/AdminContentBread.vue'
import AdminHeader from '@/components/AdminHeader.vue'
export default {
  components: {
    AdminLeftMenu,
    AdminContentBread,
    AdminHeader
  },

  data() {
    //这里是自定义的规则
    var rePasswordCheck=(rule, value, callback)=>{
      if(!value){
        return callback(new Error('请输入密码'));
      }else if(value !==this.formValidate.password){
        return callback(new Error('两次输入密码不一致!'));
      }else {
        callback()
      }
    }
    //数据
    return {
      token: '',
      associatins: [],
      formValidate: {
        userName: '',
        password: '',
        rePassword: '',
        associationId: 0,
        associationName: '',
        level: 0,
      },
      ruleValidate: {
        userName: [
          { required: true, message: '登录名不能为空', trigger: 'blur' }
        ],
        password:  [
          { required: true, message: '请您输入登录密码', trigger: 'blur' },
          //{ type: 'string', min: 8, message: '密码至少8个字符', trigger: 'blur' }
        ],
        rePassword:  [
          { required: true, message: '请您确认登录密码', trigger: 'blur' },
          {validator: rePasswordCheck}
        ],
        associationId:  [
          { type: 'number', required: true, min: 1, message: '请您选择管理所属组织', trigger: 'change' }
        ],
        level:  [
          { type: 'number', required: true, min: 1, message: '请选择栏目', trigger: 'change' }
        ],
      }
    }
  },

  //加载后执行
  mounted() {
    //初始化页面数据
    this.initAuthData()

    //获取机构数据
    this.getAssociationsList()
  },


  methods: {

    //初始化页面基础信息
    initAuthData() {
      let admin = JSON.parse(localStorage.getItem("adminInfo"));
      if(admin!=null) {
        this.token = admin.token
      }
    },

    //数据保存
    handleSubmit (name) {
      this.$refs[name].validate((valid) => {
        if (valid) {
          let vm = this  
          axios.post(
            vm.GLOBAL_API.apiUrl + "/manage/users/list-admin-add",
            vm.formValidate,
            {
              headers: {
                'content-type': 'application/json',
                "Authorization": "Bearer " + vm.token
              }
            }
          ).then(function(res) {
            let info = res.data
            let error = parseInt(info.code)
            if(error==0) {
              vm.$Message.success({
                  content: info.message,
                  duration: 1,
                  closable: true,
                  onClose:function() {
                    window.open(vm.$router.resolve({ path: '/manage/users/list'}).href)
                  }
              });
            } else {
              vm.$Message.error(info.message);
            }
            
          }).catch(function(error) {
            console.log(error)
          });
        } else {
            this.$Message.error('Fail!');
        }
      })
    },

    //获取结构列表
    getAssociationsList() {
      let vm = this  
      axios.post(
        vm.GLOBAL_API.apiUrl + "/manage/associations/association-get-for-all-list",
        {},
        {
          headers: {
            'content-type': 'application/json',
            "Authorization": "Bearer " + vm.token
          }
        }
      ).then(function(res) {
        let info = res.data
        let error = parseInt(info.code)
        if(!isNaN(error) && error==0){
          vm.associatins = info.data.list
        }
        
      }).catch(function(error) {
        console.log(error)
      });
    },

    //机构选择
    associationSelect(item) {
      //console.log(item)
      this.formValidate.associationName = item.label
    }

  }
}
</script>